import {ChecklistsTemplatesPage as ChecklistsTemplatesFeaturePage} from '@features/hroc-checklists'
import {useTranslation} from 'react-i18next'
import {useParams} from 'react-router'

import {useTranslationPrefix} from '../../shared/hooks/useTranslationPrefix'
import {LocationBreadcrumbs} from '../components'

type PathParameter = {
  plantId?: string
}

export const ChecklistsTemplatesPage = () => {
  const {plantId} = useParams<PathParameter>()
  if (!plantId) throw new Error('plantId is missing')

  const {t} = useTranslation()
  const {hrocPrefix} = useTranslationPrefix()

  return (
    <ChecklistsTemplatesFeaturePage
      plantId={plantId}
      titleSlot={t(`${hrocPrefix}.navPages.checklists`)}
      aboveTitleSlot={<LocationBreadcrumbs />}
    />
  )
}
